import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { connectionStatus } from '../../constants/leadinConfig';
import ErrorHandler from '../../shared/Common/ErrorHandler';
import FormEdit from '../../shared/Form/FormEdit';
import ConnectionStatus from '../../shared/enums/connectionStatus';
export default function FormWidgetController(attributes, setValue) {
    return () => {
        const render = () => {
            if (connectionStatus === ConnectionStatus.Connected) {
                return (_jsx(FormEdit, { attributes: attributes, isSelected: true, setAttributes: setValue, preview: false, origin: "elementor" }));
            }
            else {
                return _jsx(ErrorHandler, { status: 401 });
            }
        };
        return _jsx(Fragment, { children: render() });
    };
}
